export const LOAD_EVENT_TYPES_REQUEST = 'LOAD_EVENT_TYPES_REQUEST';
export const LOAD_EVENT_TYPES_SUCCESS = 'LOAD_EVENT_TYPES_SUCCESS';
export const LOAD_EVENT_TYPES_FAIL = 'LOAD_EVENT_TYPES_FAIL';

